import { __assign } from '../_virtual/_tslib.js';
import { themeList } from '../theme/index.js';

function buildSpindleTheme(theme) {
  var _a, _b, _c;

  var mode = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colorTokens) === null || _a === void 0 ? void 0 : _a.mode) !== null && _b !== void 0 ? _b : 'light';
  var defaultTheme = themeList[mode];
  return Object.freeze({
    fonts: __assign(__assign({}, defaultTheme.fonts), theme === null || theme === void 0 ? void 0 : theme.fonts),
    colors: __assign(__assign({}, defaultTheme.colors), theme === null || theme === void 0 ? void 0 : theme.colors),
    colorTokens: __assign(__assign(__assign({}, defaultTheme.colorTokens), theme === null || theme === void 0 ? void 0 : theme.colorTokens), {
      accent: __assign(__assign({}, defaultTheme.colorTokens.accent), (_c = theme === null || theme === void 0 ? void 0 : theme.colorTokens) === null || _c === void 0 ? void 0 : _c.accent)
    })
  });
}

export { buildSpindleTheme as default };